import { GoogleMapSettings } from './google-map-settings';
export class GlobalSettings {

  static get DateNow(): Date {
    const customDate = localStorage.getItem('custom-date');
    if (customDate) {
      return new Date(customDate);
    }

    return new Date();
  }

  dateFormat = { day: '2-digit', month: '2-digit', year: 'numeric' };

  datetimeFormat = { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' };

  onlyDayMonthFormat = { day: '2-digit', month: '2-digit' };

  shotWeekdayAndDateFormat = { weekday: 'short', day: '2-digit', month: '2-digit', year: 'numeric' }

  timeToMilliseconds(floatTime: number) {
    return floatTime * 60 * 60 * 1000;
  }

  timeToMinutes(floatTime: number) {
    return floatTime * 60;
  }

  minutesToFloat(minutes: number) {
    return minutes / 60;
  }

  toTimeString(floatTime: number): string {
    const hours = Math.floor(floatTime);
    const minutes = (floatTime - hours) * 60;

    return hours.toString().padStart(2, '0') + ':' + minutes.toFixed(0).padStart(2, '0');
  }

  toMoneyStr(x: number): string {
    return `${x.toFixed(2).replace('.', ',')} €`;
  }

  get taxRate(): number {
    return 0.19;
  }

  getTimeStr(date: Date): string {
    return this._pad(date.getHours()) + ':' + this._pad(date.getMinutes());
  }

  getTimeFloat(date: Date): number {
    return (date.getHours() * 60 + date.getMinutes()) / 60;
  }

  getCurrentLocalTimeFloat(): number {
    return this.getTimeFloat(GlobalSettings.DateNow);
  }

  getIsoDateStr(year: number, month: number, day: number): string {
    return year + '-' + this._pad(month) + '-' + this._pad(day);
  }

  getIsoDate(year: number, month: number, day: number): Date {
    return new Date(this.getIsoDateStr(year, month, day));
  }

  getIsoDateByDate(date: Date): Date {
    if (!date) {
      return null;
    }

    return this.getIsoDate(date.getFullYear(), date.getMonth() + 1, date.getDate());
  }

  getIsoDateStrByDate(date: Date): string {
    if (!date) {
      return null;
    }

    return this.getIsoDateStr(date.getFullYear(), date.getMonth() + 1, date.getDate());
  }

  getWindowName(orderId) {
    return 'order_' + orderId;
  }

  trimEndSlash(url: string): string {
    return url ? url.trim().replace(/\/$/, '') : url;
  }

  private _pad(n) {
    return n < 10 ? '0' + n : n;
  }

  get minCustomGiftCard(): number {
    return 10;
  }

  get maxCustomGiftCard(): number {
    return 500;
  }

  get minAgeForRegistration(): number {
    return 18;
  }

  get eventMinPersonCount(): number {
    return 6;
  }

  get eventMaxPersonCount(): number {
    return 20;
  }

  get singleMaxPersonCount(): number {
    return 10;
  }

  get local_currency(): string {
    return '€';
  }

  get isoCurrencyCode(): string {
    return 'EUR';
  }

  get google_map_settings() {
    const googleMapSettings = new GoogleMapSettings();
    return googleMapSettings.google_map_settings;
  }

  getAgeFromDate(date: Date): number {
    const today = GlobalSettings.DateNow;
    if (!date) {
      return null;
    }
    let age = today.getFullYear() - date.getFullYear();
    const m = today.getMonth() - date.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < date.getDate())) {
      age--;
    }
    return age;
  }

  get shopCountry(): string {
    return 'DE';
  }

  isToday(date: Date): boolean {
    return date && GlobalSettings.DateNow.toDateString() === date.toDateString();
  }

  getHourString(floatTime: number): string {
    if (floatTime == null) {
      return '';
    }
    const timeInString = this.toTimeString(floatTime);
    const array = timeInString.split(':');
    if (array.length === 2) {
      return array[0];
    }

    return '';
  }

  getMinutesString(floatTime: number): string {
    if (floatTime == null) {
      return '';
    }
    const timeInString = this.toTimeString(floatTime);
    const array = timeInString.split(':');
    if (array.length === 2) {
      return array[1];
    }

    return '';
  }
}
